import { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
type IProps = {
  id?: string;
  label: string;
  type?: any;
  placeholder?: string;
  errors?: any;
  isRequired?: boolean;
  defaultValue?: string | null;
  register: any;
  options: { label: string; value: number | string }[];
  clearIcon?: boolean;
  fieldName: string;
};
const SelectField = ({
  id,
  label,
  register,
  placeholder,
  errors,
  isRequired,
  defaultValue,
  options,
  clearIcon,
  fieldName,
}: IProps) => {
  const [selectValue, setSelectedValue] = useState(defaultValue || '');
  return (
    <div>
      <label htmlFor={id} /* className='col-form-label' */>{label}</label>{' '}
      {isRequired && <span className='require'>*</span>}
      <div style={{ position: 'relative' }}>
        <select
          {...(register
            ? register(fieldName, {
                required: isRequired ? `${label} is required` : false,
                onChange: (e: any) => {
                  setSelectedValue(e.target.value);
                },
              })
            : {})}
          required={isRequired}
          defaultValue={defaultValue}
          className='form-select'
          placeholder={placeholder || label}
          value={selectValue}
          // onChange={(v) => {
          //   setSelectedValue(v.target.value);
          // }}
        >
          <option disabled value={''}>
            Please Select
          </option>
          {options?.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {clearIcon && (
          <span
            style={{
              position: 'absolute',
              right: 13,
              top: 8,
              fontSize: '16px',
              cursor: 'pointer',
            }}
            onClick={() => {
              register()?.onChange({
                target: { name: fieldName, value: '' },
              });
              setSelectedValue('');
            }}
          >
            <RxCross2 />
          </span>
        )}
      </div>
      {errors && <div className='invalid-feedback'>{errors.message}</div>}
    </div>
  );
};

export default SelectField;
